import { isNull } from 'is-what';
import { ControlStatusService } from './control-status.service';
import { ApiConService } from './api-con.service';
import { Injectable } from '@angular/core';
import { Util, dbJasperObj, jasperObj } from './Util';
import { environment } from '../../environments/environment';
import { JsonReturn, ObjectParam } from './interface/generic-interface';

@Injectable({
  providedIn: 'root'
})
export class JasperService {
  objetoDeConexao: dbJasperObj;
  stringChaveValor: string
  objJasper: jasperObj;

  usuarioJasper = atob(environment.usuarioJasper)
  senhaJasper = atob(environment.passwordjasper)
  waitJasper: boolean = false

  constructor(private conService: ApiConService, private controlStatus: ControlStatusService) { }


  async getDadosDBeServidor(cnpjEmpresas: string): Promise<dbJasperObj> {
    try {

      let result: JsonReturn = await this.conService.patch(`DCDistribuidoraEmpresa/${cnpjEmpresas}`)
      this.objetoDeConexao = result.response[0]

      // Inicializa o objeto jasper
      this.objJasper = {
        DB: this.objetoDeConexao.DbName,
        CONEXAO: this.objetoDeConexao.IDServer.toString(),
        DTINICIO: '',
        DTFIM: '',
        CDEMP:'',
        NUROM:'',
        NOMEMOTORISTA:''
      }

      this.waitJasper = true
      return this.objetoDeConexao

    } catch (error) {
      console.log('Não foi possivel requisitar os dados esperados de conexão ao servidor Jasper');
      console.log(error);
    }
  }



  montaChaveValor() {
    let stringObj: string = ''

    // CRIA A STRING DE CHAVE VALOR
    Object.entries(this.objJasper).forEach(([key, value]) => {
      if(value!=''){
        stringObj = stringObj + '&' + key + '=' + value;
      }
    })


    return stringObj
  }


  public criaUrlConexaoJasper(reportName: string, reportType: string, caminhoRelatorio: string,  nuRom?:string): string {

    let url = '';
    // //atribui as datas
    this.objJasper.DTINICIO = this.controlStatus.dataInicio + ' 00:00:00' ;
    this.objJasper.DTFIM = this.controlStatus.dataFim + ' 23:59:59';

    nuRom == undefined ? this.objJasper.NUROM = '' : this.objJasper.NUROM = nuRom;
    this.controlStatus.empresaSelecionada == null ?  this.objJasper.CDEMP='' : this.objJasper.CDEMP = this.controlStatus.empresaSelecionada;
    let stringChaveValor = this.montaChaveValor();
     url = environment.urlBaseJasper +
      '/ROTAPLAN/' +
      this.objJasper.CONEXAO +
      '/' +
      caminhoRelatorio +
      '/' +
      reportName +
      '&j_username=' +
      this.usuarioJasper +
      '&j_password=' +
      this.senhaJasper +
      '&output=' +
      reportType +
      stringChaveValor;

    return url
  }

  public async carregaUrlJasper(reportName: string, reportType: string,  nuRom?:string): Promise<string> {
    let url = '';

    this.objJasper.DTINICIO = this.controlStatus.dataInicio + ' 00:00:00' ;
    this.objJasper.DTFIM = this.controlStatus.dataFim + ' 23:59:59';
    this.objJasper.NOMEMOTORISTA = this.controlStatus.nomeMotorista;
    nuRom == undefined ? this.objJasper.NUROM = '' : this.objJasper.NUROM = nuRom;
    this.controlStatus.empresaSelecionada == null ?  this.objJasper.CDEMP='' : this.objJasper.CDEMP = this.controlStatus.empresaSelecionada;
    let stringChaveValor = this.montaChaveValor();
    
    let objParam: ObjectParam = {
      jasperURL: {
        JasperName: reportName.slice(0, -3),
        JasperTipo: reportType,
        JasperParam: '&output=' + reportType + stringChaveValor
      }
    };

    let result: JsonReturn = await this.conService.patchGeraRoteiro(`DCroteiros/gera-relatorio`,objParam);

    if(result.sucesso){
      url = result.response;
    }else{
      console.error("Não foi possível gerar o relátorio.");
    }

    return url;
  }
}
